import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconStarRoundFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 25 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <g clipPath="url(#icon-star-round-fill__a)">
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M11.561 5.316a.5.5 0 0 1 .904 0l1.781 3.756a.5.5 0 0 0 .377.28l4.015.607a.5.5 0 0 1 .28.846l-2.93 2.973a.5.5 0 0 0-.136.432l.688 4.176a.5.5 0 0 1-.733.52l-3.554-1.944a.5.5 0 0 0-.48 0L8.22 18.906a.5.5 0 0 1-.734-.52l.689-4.176a.5.5 0 0 0-.138-.433l-2.93-2.972a.5.5 0 0 1 .282-.846l4.014-.607a.5.5 0 0 0 .377-.28l1.781-3.756Z"
        vectorEffect="non-scaling-stroke"
      />
    </g>
    <defs>
      <clipPath id="icon-star-round-fill__a">
        <path fill="currentColor" d="M.013 0h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgIconStarRoundFill);
export default Memo;
